













import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '../../../lib/util'
import sqlForFrom from "@/views/tool/sqlMaintain/sqlForFrom.vue";
@Component({ components: {sqlForFrom}})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) patient:any;
    title="";
    created() {
        console.log(this.patient)
      this.title = this.patient.name+"随访记录";
    }
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
        this.$emit('on-success')
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
            this.$emit('on-success')
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followForm/followDoctorForSql.vue